// Mock data for Xeno homepage replica

export const navLinks = [
  {
    label: 'Product',
    hasDropdown: true,
    items: [
      { label: 'Next Gen CRM', href: '#' },
      { label: 'Next Gen Loyalty', href: '#' },
      { label: 'Next Gen Offers', href: '#' },
    ],
  },
  {
    label: 'Success',
    hasDropdown: true,
    items: [
      { label: 'Success Stories', href: '#' },
      { label: 'ROI Calculator', href: '#' },
    ],
  },
  {
    label: 'Resources',
    hasDropdown: true,
    items: [
      { label: 'Blogs', href: '#' },
      { label: 'Guides', href: '#' },
      { label: 'Podcast', href: '#' },
      { label: 'Xeno Pulse', href: '#' },
    ],
  },
  {
    label: 'Work With Xeno',
    hasDropdown: true,
    items: [
      { label: 'Careers', href: '#' },
      { label: 'Contact Us', href: '#' },
    ],
  },
];

export const trustedLogos = [
  { name: 'Shoppers Stop', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031d48b853f922b7d872_logo.png' },
  { name: 'Logo 1', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031cc946ba9bb8bca41c_logo-1.png' },
  { name: 'Logo 2', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031cf6439a612bc45dfa_logo-2.png' },
  { name: 'Logo 3', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031ca2c988811baf57ab_logo-3.png' },
  { name: 'Logo 4', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031c6cd0cbd1ddf0c0e2_logo-4.png' },
  { name: 'Logo 5', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031cbe61863aa106d158_logo-5.png' },
  { name: 'Logo 11', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031cf5336029bc3c26df_logo-11.png' },
  { name: 'Logo 16', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031d4b1ef98149c45bba_logo-16.png' },
  { name: 'Logo 12', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031ce8fabda903d9347a_logo-12.png' },
  { name: 'Logo 13', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031c8388b82f30ca94dc_logo-13.png' },
  { name: 'Logo 17', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031d1f395f045562b68f_logo-17.png' },
  { name: 'Logo 15', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/689b031d8b551ad5eab6e9e3_logo-15.png' },
  { name: 'Nandos', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/6961011275b8761a851c4f11_Nandos-Logo.png' },
  { name: 'Corporate', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/6961010c23f6668b8e188fa3_Corporate-Logo-2-e1701415995308.png' },
  { name: 'Pizza Express', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/69610112ee425d7539cf1bfa_PizzaExpress-Logo.wine.png' },
  { name: 'Kama Ayurveda', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/696106a4285128e6df8992ba_Kama-Ayurveda-logo.png' },
  { name: 'Logo Extra', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/6901966570f3b57ab9240f5f_logo.png' },
  { name: 'Logo Extra 2', url: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/696105ea71f70558fb8253bd_images.png' },
];

export const platformFeatures = [
  {
    title: 'CRM',
    description: 'Engage customers with personalised communications across multi-channels',
    link: '#',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65364fbd53477d294f956420_static%20website%20illustrations-02%20(1).webp',
  },
  {
    title: 'LOYALTY',
    description: 'Delight your most valuable customers with exclusive rewards & experiences',
    link: '#',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/6538a1afe7226b84c55acf36_Hero%20section%20illustratio%20%201.webp',
  },
  {
    title: 'OFFERS',
    description: 'Acquire & retain customers with better offers tailored to their specific behaviors',
    link: '#',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/6538a49bc48b00977e2115c8_Hero%20section%20illustratio%20%201%20(1).webp',
  },
];

export const testimonials = [
  {
    id: 0,
    logo: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65363b9c842fb6afd9ea3ad7_image%2033.webp',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65363b07b6791881decd59b1_Group%20427320018.webp',
    quote: 'We knew digital is the way ahead for CRM. Xeno being the leading player for digital CRM for retailers in India became the right fit for us to kickstart our digital CRM journey. Now we\'re happy to say that our thought process has been validated with an 40% uplift on Digital over SMS campaigns during black friday sale.',
    author: 'Nazif Tejani,',
    role: 'Lead - CRM, Bestseller',
    caseStudy: '#',
  },
  {
    id: 1,
    logo: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65363b9ca4357f6f2b4df927_image%2033-3.webp',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65363b07bd2e298c566a8b83_Group%20427320022.webp',
    quote: 'We used to do carpet bombing but now with Xeno\'s AI we personalise the communications basis customer clusters. We can now understand consumers better and personalise communications to them based on their lifestyle, interest and the products they like to buy which is extremely critical in today\'s time.',
    author: 'Dhruv Bogra,',
    role: 'Country Manager, Forever New',
    caseStudy: null,
  },
  {
    id: 2,
    logo: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/62af21ed4bde0ed31f5d7b14_taco-bell.svg',
    image: 'https://cdn.prod.website-files.com/620353a026ae70e21288308a/65363b0703e27760e1fab1b3_Group%209.webp',
    quote: 'If you need a partner who understands your business, if you need a partner who understands how the whole CRM thing comes about, from how the integration happens to how the personas are built & how the customer bucketing happens. Then Xeno\'s for you.',
    author: 'Tushar Mehta,',
    role: 'VP Marketing, Taco Bell',
    caseStudy: '#',
  },
];

export const stats = [
  { value: '60x', label: 'ROI on Marketing Spends' },
  { value: '12%', label: 'Repeat Sales' },
  { value: '15%', label: 'Reduction in Single-Visit' },
];

export const footerLinks = {
  solutions: [
    { label: 'Next Gen CRM', href: '#' },
    { label: 'Next Gen Loyalty', href: '#' },
    { label: 'Next Gen Offers', href: '#' },
  ],
  customerSuccess: [
    { label: 'Xeno Success Stories', href: '#' },
    { label: 'Xeno ROI Calculator', href: '#' },
  ],
  industries: [
    { label: 'Fashion & Apparels', href: '#' },
    { label: 'Beauty & Cosmetics', href: '#' },
    { label: 'Restaurants', href: '#' },
  ],
  resources: [
    { label: 'Retail Marketing Calendar', href: '#' },
    { label: 'Xeno Pulse', href: '#' },
    { label: 'Blogs', href: '#' },
    { label: 'Guides', href: '#' },
    { label: 'Podcast', href: '#' },
  ],
  company: [
    { label: 'Careers', href: '#', badge: "We're Hiring" },
    { label: 'Contact Us', href: '#' },
    { label: 'Get A Demo', href: '#' },
  ],
};
